import React from "react";
import { Plus, X } from "lucide-react";

interface ProductCardProps {
    title: string;
    product: {
        productId?: number;
        id?: number;
        productName?: string;
        name?: string;
        brandName?: string;
        price: number | string;
        thumbnail?: string;
        imageUrl?: string;
        productImage?: string;
    } | null;
    onClick: () => void;
    onRemove: () => void;
}

const ProductCard: React.FC<ProductCardProps> = ({
    title,
    product,
    onClick,
    onRemove,
}) => {
    // Standardize data naming properties dynamically from the API schemas
    const displayName = product?.productName || product?.name || "Unnamed Item";
    const displayBrand = product?.brandName || "";
    const displayImage = product?.thumbnail || product?.imageUrl || product?.productImage;
    const displayPrice = typeof product?.price === "number" ? `AED ${product.price.toFixed(2)}` : product?.price;

    return (
        <div
            onClick={onClick}
            className="w-[250px] rounded-2xl border border-gray-200 bg-white p-4 shadow-3xs cursor-pointer hover:border-[#6DBE45] transition flex flex-col justify-between min-h-[220px]"
        >
            {!product ? (
                <div className="h-[180px] flex flex-col items-center justify-center gap-3 flex-1">
                    <div className="w-12 h-12 rounded-full bg-slate-50 flex items-center justify-center text-slate-500 border border-slate-100 shadow-3xs">
                        <Plus size={20} />
                    </div>
                    <p className="font-bold text-xs text-gray-500 uppercase tracking-wide">{title}</p>
                </div>
            ) : (
                <div className="relative w-full flex-1 flex flex-col justify-between">
                    {/* REMOVE BUTTON */}
                    <button
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            onRemove();
                        }}
                        className="absolute -top-1 -right-1 w-6 h-6 rounded-xl bg-slate-50 border border-slate-200 hover:bg-red-50 hover:text-red-600 flex items-center justify-center transition cursor-pointer z-10 shadow-3xs"
                    >
                        <X size={12} className="stroke-[2.5]" />
                    </button>

                    {/* PRODUCT CONTENT */}
                    <div className="flex flex-col items-center text-center gap-3 w-full">
                        {/* IMAGE CONTAINER */}
                        <div className="w-24 h-24 bg-slate-50 rounded-xl flex items-center justify-center p-2 mt-2 overflow-hidden shrink-0">
                            {displayImage ? (
                                <img
                                    src={displayImage}
                                    alt={displayName}
                                    className="max-w-full max-h-full object-contain"
                                />
                            ) : (
                                <div className="text-[10px] font-bold text-gray-300">No Image</div>
                            )}
                        </div>

                        {/* DETAILS SUMMARY */}
                        <div className="w-full space-y-1">
                            <h2 className="text-xs font-bold text-slate-800 line-clamp-2 min-h-[32px]">
                                {displayName}
                            </h2>
                            <div>
                                {displayBrand && (
                                    <p className="text-[10px] text-gray-400 font-semibold">
                                        {displayBrand}
                                    </p>
                                )}
                                <p className="text-base font-black text-mainBrandColor mt-1">
                                    {displayPrice}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProductCard;